import {
  EMAIL_DOMAIN_CORRECTION_MAP,
  EMAIL_VALIDATION_PATTERN
} from "../../views/authentication/constants";

export const validateEmail = ({ email, trans, isSuggestEmailDomain }) => {
  if (!email) {
    return trans("Email is required.");
  }
  if (!isValidEmailFormat(email)) {
    return trans("This is not a valid email.");
  }
  if (isSuggestEmailDomain) {
    return suggestEmailDomain(email, trans);
  }
  return null;
};

const isValidEmailFormat = email => {
  const regex = EMAIL_VALIDATION_PATTERN;
  return new RegExp(regex).test(email);
};

const suggestEmailDomain = (value, t) => {
  const correctionMap = EMAIL_DOMAIN_CORRECTION_MAP;

  const [localPart, domain] = value.split("@");

  if (!localPart || !domain) {
    return null;
  }

  const correctedDomain = correctionMap[domain.toLowerCase()];

  if (!correctedDomain) {
    return null;
  }

  return (
    t("Did you mean:") +
    ` ${localPart}@${correctedDomain}:isEmailDomainSuggestion`
  );
};

export const parseSuggestedEmailMessage = message => {
  const [msg, suggestion] = message.split(":");

  return {
    msg: msg.trim() + ":",
    suggestion: suggestion.trim()
  };
};
